<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SGI2xF/tc-custom/9781488000911.jpg?1726444269516" alt="This image is the cover for the book Heir to Make a Marriage, One Night With Consequences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heir to Make a Marriage, One Night With Consequences
      </h1>
      <p class="bookDescription body article font2">
        <b>A maid in Manhattan pulls the wool over a billionaire’s eyes in this “fabulous Cinderella story” from the <i>USA Today</i>–bestselling author (Lynne Graham).</b><br/><br/>In desperation to save her father, housekeeper Rose O’Malley thinks she can trap a man. But the second she faces Zac Valenti and the force of his palpable sensuality, she knows she can’t go through with it! <br/><br/>Before she can call off her deception, Manhattan’s most eligible bachelor sweeps Rose off her feet—and into his bed! Stealing away like a guilty Cinderella, Rose vows never to see Zac again . . . until she discovers she’s pregnant and Zac demands his passionate betrayer and his baby remain under his control.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Abby Green
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?580b159f